import { ReactNode } from "react"

export const Section = ({ children }: { children: ReactNode }) => {
  return (
    <section className="w-full rounded-[4px] bg-secondary sm:p-8">
      {children}
    </section>
  )
}
